import React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import MuiDialogTitle, { DialogTitleProps as MuiDialogTitleProps } from '@material-ui/core/DialogTitle';

const styles = () =>
  createStyles({
    root: {},
  });

export interface DialogTitleProps extends Omit<MuiDialogTitleProps, 'classes'>, WithStyles<typeof styles> {}

const DialogTitle: React.FC<DialogTitleProps> = ({ classes, ...rest }) => (
  <MuiDialogTitle
    classes={{
      root: classes.root,
    }}
    {...rest}
  />
);

export default withStyles(styles, { name: 'LumaDialogTitle' })(DialogTitle);
